import GenericObject from './genericobject';

/**
 * An MDX helper.
 */
export default class Helper extends GenericObject {}
